import { css } from '@emotion/core';

const Container = css`
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export default Container;
